module.exports = "https://web-assets-production.autolist.com/_next/static/images/suv-13a86b9359f0e0318440d6f11b81792e.png";